import { render, staticRenderFns } from "./UserGoods.vue?vue&type=template&id=7f8ad71a&scoped=true&"
import script from "./UserGoods.vue?vue&type=script&lang=js&"
export * from "./UserGoods.vue?vue&type=script&lang=js&"
import style0 from "./UserGoods.vue?vue&type=style&index=0&id=7f8ad71a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8ad71a",
  null
  
)

export default component.exports